module.exports = __webpack_public_path__ + "d6413ba1/img/placeholder.888fcd0b.svg";